export default __webpack_public_path__ + "static/media/tailwindLogo.6a531bbc.png";